import { buildApiUrl } from "./apiConfig";

const ensureFetcher = (fetchWithAuth) => {
  if (typeof fetchWithAuth !== "function") {
    throw new Error("fetchWithAuth is required.");
  }
  return fetchWithAuth;
};

async function parseJsonResponse(response, fallbackMessage) {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.detail || fallbackMessage);
  }
  return payload;
}

const enhanceDrive = (drive = {}) => ({
  ...drive,
  beforePhotoEndpoint: drive.before_photo_id
    ? buildApiUrl(`/admin/drives/photos/${drive.before_photo_id}`)
    : null,
  afterPhotoEndpoint: drive.after_photo_id
    ? buildApiUrl(`/admin/drives/photos/${drive.after_photo_id}`)
    : null,
});

export async function fetchAdminDrives(fetchWithAuth) {
  const runner = ensureFetcher(fetchWithAuth);
  const response = await runner(buildApiUrl("/admin/drives"));
  const payload = await parseJsonResponse(response, "Fahrten konnten nicht geladen werden.");
  return Array.isArray(payload?.drives) ? payload.drives.map(enhanceDrive) : [];
}

export async function reviewAdminDrive(fetchWithAuth, pathId, review) {
  const runner = ensureFetcher(fetchWithAuth);
  const response = await runner(buildApiUrl(`/admin/drives/${pathId}/review`), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(review),
  });
  const payload = await parseJsonResponse(response, "Fahrt konnte nicht geprüft werden.");
  return payload?.drive ? enhanceDrive(payload.drive) : null;
}

export async function fetchAdminDriveGeometry(fetchWithAuth, pathId) {
  const runner = ensureFetcher(fetchWithAuth);
  const response = await runner(buildApiUrl(`/admin/drives/${pathId}/geodata`));
  const payload = await parseJsonResponse(response, "Fahrtroute konnte nicht geladen werden.");
  const raw = payload?.path_geometry?.geometry_geojson;
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch {
    throw new Error("Fahrtroute konnte nicht gelesen werden.");
  }
}
